import type { VesselCardChartRow, VesselCardFuelGrade } from "../models/vessel-card.models";
import VesselCardPerformanceChart from "./VesselCardPerformanceChart";

interface VesselCardPerformanceGraphProps {
  rows: VesselCardChartRow[];
  comparison: "cp" | "baltic";
  sourceLabel: string;
  fuelGrade: VesselCardFuelGrade;
}

const VesselCardPerformanceGraph = ({ rows, comparison, sourceLabel, fuelGrade }: VesselCardPerformanceGraphProps) => {
  const comparisonLabel = comparison === "cp" ? "CP Description" : "Baltic Index Ship";
  return (
    <div
      className="rounded-lg border border-gray-200 p-4 dark:border-gray-700"
      data-test="vessel-card-performance-graph"
    >
      <h3 className="text-sm font-semibold text-teal-600 dark:text-teal-300" data-test="vessel-card-graph-title">
        Expected Performance vs {comparison === "cp" ? "CP Description" : "Baltic Ship"}
      </h3>
      <div className="my-3 flex flex-wrap justify-between gap-2 text-xs">
        <p
          className="font-semibold text-amber-600 dark:text-amber-400"
          data-test="vessel-card-graph-fuel-grade"
          aria-live="polite"
        >
          Fuel grade: {fuelGrade ?? "Not available"}
        </p>
        <p className="text-gray-500 dark:text-gray-400" data-test="vessel-card-graph-source" aria-live="polite">
          {comparison === "cp" ? "CP source" : "Baltic index"}: {sourceLabel} · Expected curve interval: 0.1 kn
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {(["Ballast", "Laden"] as const).map((condition) => (
          <VesselCardPerformanceChart
            key={condition}
            condition={condition}
            rows={rows}
            comparisonLabel={comparisonLabel}
            comparisonKey={comparison}
          />
        ))}
      </div>
      <p className="mt-3 text-xs leading-5 text-gray-500 dark:text-gray-400" data-test="vessel-card-curve-disclaimer">
        Each plot scales independently. The Expected line uses the workbook's 2.8 power law, 2 t/day auxiliary
        allowance, 0.1 kn steps and explicit endpoint values.
      </p>
    </div>
  );
};

export default VesselCardPerformanceGraph;
